import React from "react"
import { useStore } from "@/store"
import { DOT_SIZE, getCurrentTimeRangeState, useCurrentTime } from "./_utils"

type CurrentTimeLineLayerProps = {
  startHour: number
  endHour: number
}

const CurrentTimeLineLayer: React.FC<CurrentTimeLineLayerProps> = ({ startHour, endHour }) => {
  const { calendarDimensions } = useStore()
  const currentTime = useCurrentTime()
  const { hourDiff, inRange } = getCurrentTimeRangeState(currentTime, startHour, endHour)

  const currentTimeTop =
    calendarDimensions.timeline.offset / 2 +
    hourDiff * calendarDimensions.timeline.offset +
    (currentTime.minute / 60) * calendarDimensions.timeline.offset

  if (!inRange) {
    return null
  }

  return (
    <div
      className="absolute left-0 touch-none pointer-events-none items-center z-10"
      style={{
        top: currentTimeTop,
        width: calendarDimensions.canvas.width,
        height: 1,
      }}
      data-testid="panel-reservations-calendar-current-time"
    >
      <div
        className="absolute border-0 border-b border-dashed border-[#888c8d]"
        style={{
          left: DOT_SIZE / 2,
          width: calendarDimensions.canvas.width - DOT_SIZE / 2,
          height: 0,
        }}
        data-testid="current-time-line"
      />
    </div>
  )
}

export default CurrentTimeLineLayer
